<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                      <FormItem label="发票" prop="invoice_image">
                        <Input v-model="Forms.invoice_image[0]" disabled>
                          <template #append>
                            <div class="f-center">
                              <Upload
                                  :show-upload-list="false"
                                  :action="upload_url"
                                  :headers = "{'token': $store.state.token}"
                                  :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                  :max-size="50 * 1024"
                                  :on-success="handleInvoiceSuccess"
                                  :on-format-error="handleFormatError"
                                  :on-exceeded-size="handleMaxSize">
                                <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                              </Upload>
                              <Divider type="vertical" />
                              <a href="javascript:void(0);" @click="FileDelete('invoice_image')" class="text-danger"><Icon type="md-trash" />删除</a>
                              <Divider type="vertical" />
                              <a href="javascript:void(0);" @click="FileDownload(Forms.invoice_image[0])" class="text-violet"><Icon type="md-download" />下载</a>
                            </div>
                          </template>
                        </Input>
                      </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>

    </Drawer>
</template>

<script>

import {getExpendDetail, invoiceSaveExpend} from "@/apis/expend";

export default {
    name: 'ExpendInvoice',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '上传发票',
            isBox : false,
            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : '',

            Forms : {
                expend_id: '',
                invoice_image: []
            },
            Rules : {

            }
        }
    },
    methods: {
      /**
       功能：图片文件
       time: 2025/12/17 10:48
       **/
      FileDelete(f){
        let that = this;
        that.Forms[f] = [];
      },
      /**
       功能：
       time: 2025/12/19 18:12
       **/
      FileDownload(url){
        let that = this;
        if(url){
          //下载文件
          const fileUrl = that.site_url + url; // 文件的URL地址
          const parts = fileUrl.split('/');
          const fileName = parts[parts.length - 1];
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.setAttribute('download', fileName);
          link.click();
        }else{
          that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
        }
      },
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：图片删除
         time: 2025/12/15 10:21
         **/
        PhotoInvoiceDelete(index){
            let that = this;
            that.Forms.invoice_image.splice(index , 1);
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleInvoiceSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.invoice_image = [res.data.url];
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | gif 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '图片大小不能超出 10M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        handleInvoiceBeforeUpload(){
            let that = this;
            if(that.Forms.invoice_image.length >= 10){
                that.$Message.error({ background: true,duration:3, content: '最多只能上传 10 张图' });
                return false;
            }
            return true;
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2026/1/6 14:57
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendDetail(id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'invoice_image') {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },

        /**
         功能：
         time: 2026/1/6 11:47
         **/
        edit(expend_id){
            this.isBox = true;
            if(expend_id) this.GetDetail(expend_id);
        },
        /**
         功能：
         time: 2025/12/25 17:38
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    invoiceSaveExpend(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/27 10:00
         **/
        FormReset(){
            this.isBox = false;
            this.$refs['Forms'].resetFields();
            this.Forms.expend_id = '';
            this.Forms.invoice_image = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
